import React from "react";
import { Box, Button as MatButton, Grid2 } from "@mui/material";
import PageHeader, {
} from "../../../../shared/PageHeader/PageHeader";
import PageWrapper from "../../../../shared/PageWrapper/PageWrapper";
import ViewTableWrapper from "../../../../shared/ViewTableWrapper/ViewTableWrapper";import CandidateInterviewTrackerListView from "./CandidateInterviewTrackerListView";

const CandidateInterviewTrackerListing: React.FC = () => {
  return (
    <>
      <PageWrapper>
        <Grid2 container>
          <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
            <PageHeader title="Interview Tracker" />
          </Grid2>
        </Grid2>

        <Box marginTop={1} className="interview-list-wrap">
          <ViewTableWrapper.Content
            sx={{
              padding: { xs: "0", md: "0" },
            }}
          >
            <Box m={0}>
              <CandidateInterviewTrackerListView />
            </Box>
          </ViewTableWrapper.Content>
        </Box>
      </PageWrapper>
    </>
  );
};

export default CandidateInterviewTrackerListing;
